export default __webpack_public_path__ + "static/media/linkedin.981931b1.svg";